import { render, staticRenderFns } from "./moreQrcode.vue?vue&type=template&id=310fddbc&scoped=true&"
import script from "./moreQrcode.vue?vue&type=script&lang=js&"
export * from "./moreQrcode.vue?vue&type=script&lang=js&"
import style0 from "./moreQrcode.vue?vue&type=style&index=0&id=310fddbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310fddbc",
  null
  
)

export default component.exports